<template>
  <div class="grid pb-0">
    <div class="grid-title">
      <h4>{{ $t("SERVICES") }}</h4>
      <div>
        <v-row>
          <v-col class="text-right pt-0 pb-0">
            <!-- <v-btn color="warning" v-if="radioGroup === true && selected.length > 0" @click="dialog = true" class="mr-3">{{ $t("DEACTIVE") }}</v-btn>
            <v-btn color="success" v-if="radioGroup === false && selected.length > 0" @click="dialogActive = true" class="mr-3">{{ $t("SERVICE.ACTIVE") }}</v-btn>
            <v-btn color="error" v-if="selected.length > 0" @click="$refs.deleteDialogComponentList.open(selected)" class="mr-3">{{ $t("DELETE") }}</v-btn> -->
            <v-btn color="primary" @click="addNew">
              <v-icon dark>
                mdi-plus
              </v-icon>
              {{ $t("ADD_NEW_SERVICE") }}
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
    <div class="grid-body border-top-unset">
      <v-row align="center" class="pb-3 pr-3 pl-3">
        <v-col sm="4">
          <v-text-field v-model="keyword" :label="$t('ENTER_NAME_OR_CODE')" v-on:change="getAll(true)"
            class="mt-0 pt-0"></v-text-field>
        </v-col>
        <v-col>
          <v-radio-group row v-model="radioGroup" class="mt-0" @change="$event => getAll(true)">
            <v-radio v-for="item in optionFilter" :key="item.key" :label="item.label" :value="item.key"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-progress-linear color="warning" indeterminate rounded height="3" v-if="isLoading"></v-progress-linear>
      <div>
        <v-simple-table fixed-header height="calc(100vh - 269px)">
          <!-- <template v-slot:default> -->
          <thead>
            <tr>
              <!-- <th width="3%" scope="col">
                <label class="form-checkbox">
                  <input class="v-input--selection-controls__input" type="checkbox" :value="true" v-model="checkAll"
                    @change="getAll(true)">
                  <i class="form-icon"></i>
                </label>
              </th> -->
              <th width="50px" class="text-center vertical-middle" scope="col">{{ $t("STT") }}</th>
              <!-- <th width="7%"  class="text-left"  scope="col" v-if="radioGroup === 'all' || radioGroup == true"><span>{{ $t("SERVICE.ORDER") }}</span></th> -->
              <th class="text-left" scope="col">{{ $t("SERVICE.CODE") }}</th>
              <th class="text-left" scope="col">{{ $t("SERVICE.NAME") }}</th>
              <th class="text-left" scope="col">{{ $t("SERVICE.PRICE_STATUS") }}</th>
              <th width="10%" class="text-center vertical-middle" scope="col">{{ $t("SERVICE.STATUS") }}</th>
              <th width="10%" class="text-center vertical-middle" scope="col">{{ $t("ACTION") }}</th>
            </tr>
          </thead>
          <draggable v-if="!isLoading" v-model="dataTable" tag="tbody" animation="150" handle=".sortHandle"
            @end="changeOrderListService">
            <template v-if="dataTable.length > 0 && !isLoading">
              <tr v-for="(item, i) in dataTable" :key="i">
                <!-- <td width="3%" class="vertical-middle">
                  <label class="form-checkbox">
                    <input class="v-input--selection-controls__input" type="checkbox" :value="item" v-model="selected"
                      @change="checkAllSelect()">
                    <i class="form-icon"></i>
                  </label>
                </td> -->
                <td class="text-center vertical-middle" width="50px">{{ i + 1 }}</td>
                <!-- <td width="7%" class="vertical-middle" v-if="radioGroup === 'all' || radioGroup == true"><v-btn style="cursor: move" icon class="sortHandle"><v-icon>drag_handle</v-icon></v-btn></td> -->
                <td class="vertical-middle">
                  {{ item.serviceCode }}
                </td>
                <td class="font-weight-bold vertical-middle">
                  <a class="app-link text-decoration-none" href="javascript:;" @click="editItem(item)">
                    {{ item.serviceI18n.find(x => x.lang == defaultI18n).name }}
                  </a>
                </td>
                <td class="text-left vertical-middle">
                  <div v-if="item.free">
                    {{ $t("SERVICE.FREE") }}
                  </div>
                  <div v-else>
                    {{ $t("SERVICE.PREMIUM") }}
                  </div>
                </td>
                <td width="10%" class="text-center vertical-middle">
                  <div class="d-flex justify-center">
                    <v-switch v-model="item.status" @change="updateStatus(item)"
                      class="service-status mt-0 pt-0"></v-switch>
                  </div>
                </td>
                <td width="10%" class="text-center vertical-middle d-flex">
                  <v-tooltip top transition="slide-y-reverse-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn depressed @click="editItem(item)" x-small class="rounded-sm mr-1" v-bind="attrs" v-on="on"
                        color="primary" outlined>
                        <i class="icon-edit fs-16"></i>
                      </v-btn>
                    </template>
                    {{ $t("EDIT") }}
                  </v-tooltip>
                  <v-tooltip top transition="slide-y-reverse-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn depressed color="error" @click="$refs.deleteDialogComponent.open(item)" x-small
                        v-bind="attrs" v-on="on" class="rounded-sm" outlined>
                        <i class="icon-delete fs-16"></i>
                      </v-btn>
                    </template>
                    {{ $t("DELETE") }}
                  </v-tooltip>
                  <v-tooltip top transition="slide-y-reverse-transition"
                    v-if="radioGroup === 'all' || radioGroup == true">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn depressed x-small v-bind="attrs" v-on="on" class="rounded-sm sortHandle ml-1" outlined
                        style="cursor: move">
                        <v-icon size="15">
                          mdi-arrow-all
                        </v-icon>
                      </v-btn>
                    </template>
                    {{ $t("SORT") }}
                  </v-tooltip>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td colspan="8" class="text-center vertical-middle font-weight-bold font-italic" style="color:red">
                  {{ $t('NO_DATA') }}
                </td>
              </tr>
            </template>
          </draggable>
          <!-- </template> -->
        </v-simple-table>
        <b-row>
          <b-col md="4" class="d-flex align-center">
          </b-col>

          <b-col md="4" class="text-center">
            <a v-if="dataTable.length < paging.total" class="text-primary" @click="showMore()">{{
              $t('SHOW_MORE')
            }}
              <i class="icon-keyboard_double_arrow_down"> </i>
            </a>
          </b-col>
          <b-col md="4" class="text-right">
            <span v-if="paging" class="pr-3">{{ $tc('TO_PAGE', dataTable.length) }} | {{ $t("TOTAL") }}: {{ paging.total
            }}
              {{ $t("SERVICES") }}</span>
          </b-col>
        </b-row>
        <delete-dialog @deleteItem="deleteService" :maxWidth="325" ref="deleteDialogComponent">
          <span slot="title">{{ $t("SERVICE.CONFIRM_DELETE_SERVICE") }}?</span>
        </delete-dialog>
        <delete-dialog @deleteItem="deleteServiceList" :maxWidth="325" ref="deleteDialogComponentList">
          <span slot="title">{{ $t("SERVICE.CONFIRM_DELETE_SERVICE") }}</span>
        </delete-dialog>
        <v-dialog v-model="dialog" max-width="418">
          <v-toolbar class="toolbar-update" dense>
            <v-toolbar-title class="text-primary fs-15">
              <strong>{{ $t('NOTIFICATION') }}</strong>
            </v-toolbar-title>
          </v-toolbar>
          <div class="content-update">
            <label class="s-label">{{ $t('SERVICE.CONFIRM_DEACTIVE_SERVICE') }}</label>
            <div class="mt-3 d-flex justify-content-between">
              <div class="w-100 mr-1">
                <v-btn depressed block @click="dialog = false">
                  {{ $t("_LOGIN.CANCEL") }}
                </v-btn>
              </div>
              <div class="w-100 ml-1">
                <v-btn block color="primary" @click="deactiveAll">
                  {{ $t("CONFIRM") }}
                </v-btn>
              </div>
            </div>
          </div>
        </v-dialog>
        <v-dialog v-model="dialogActive" max-width="325">
          <v-toolbar class="toolbar-update" dense>
            <v-toolbar-title class="text-primary fs-15">
              <strong>{{ $t('NOTIFICATION') }}</strong>
            </v-toolbar-title>
          </v-toolbar>
          <div class="content-update">
            <label class="s-label">{{ $t('SERVICE.CONFIRM_ACTIVE_SERVICE') }}</label>
            <div class="mt-3 d-flex justify-content-between">
              <div class="w-100 mr-1">
                <v-btn depressed block @click="dialogActive = false">
                  {{ $t("_LOGIN.CANCEL") }}
                </v-btn>
              </div>
              <div class="w-100 ml-1">
                <v-btn block color="primary" @click="deactiveAll">
                  {{ $t("CONFIRM") }}
                </v-btn>
              </div>
            </div>
          </div>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.table-syncPMS {
  padding: 0;

  .v-card__text {
    padding: 0;
  }
}

#service-list {
  td {
    vertical-align: middle;
  }

  button.sortHandle {
    outline: none;
  }

  .service-status {
    justify-content: center;
    margin-top: 5px;
  }
}
</style>

<script>
import Paging from "@/components/Utils/Paging.vue";
import { _formatCurrency, _formatDate, _alert } from "@/_helpers/function.js";
import DeleteDialog from "@/components/Utils/DeleteDialog.vue";
import ConfirmDialog from "@/components/Utils/ConfirmDialog.vue";
import { servicePackageService } from "@/_services/Service/service.service.js";
import draggable from "vuedraggable";
const toLower = text => {
  return text.toString().toLowerCase()
}
export default {
  components: {
    "delete-dialog": DeleteDialog,
    "confirm-dialog": ConfirmDialog,
    paging: Paging,
    draggable
  },
  data() {
    return {
      dialog: false,
      dialogActive: false,
      checkAll: false,
      isLoading: false,
      headers: [
        {
          text: this.$t("STT"),
          class: "text-center"
        },
        {
          text: this.$t("SERVICE.THUMBNAIL"),
          value: "defaultImageThumbUrl",
          width: "120px"
        },
        {
          text: this.$t("SERVICE.CODE"),
          value: "serviceCode"
        },
        {
          text: this.$t("SERVICE.NAME"),
          value: "serviceI18n",
        },
        {
          text: this.$t("SERVICE.PRICE_STATUS"),
          value: "free",
        },
        {
          text: this.$t("SERVICE.STATUS"),
          class: "text-center",
          value: "status",
        },
        {
          text: this.$t("ACTION"),
          class: "text-center",
          value: "action",
        }
      ],
      sysLang: this.$i18n.locale || "vi",
      radioGroup: 'all',
      selected: [],
      listService: [],
      listFilter: [],
      dragging: false,
      dialog: false,
      paging: {
        total: 0,
        limit: 15,
        offset: 0
      },
      selected: [],
      optionFilter: [
        {
          label: this.$t("ALL"),
          key: 'all'
        },
        {
          label: this.$t("SERVICE.ACTIVE"),
          key: 1
        },
        {
          label: this.$t("SERVICE.DEACTIVE"),
          key: 0
        }
      ],
      keyword: null,
      dataTable: [],
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.isLoading = true;
      this.getAll(true)
    },
    async getAll(isSearching) {
      // this.$session.set("ojbListOfSalePackage", this.paging);
      this.isLoading = true;
      if (isSearching) {
        this.paging.offset = 0;
        // this.data = [];
        this.dataTable = [];
      }
      let body = {};
      body.keyword = this.keyword;
      if (this.radioGroup === "all") {
        body.status = null;
      } else {
        body.status = this.radioGroup;
      }
      body.limit = this.paging.limit;
      body.offset = this.paging.offset;
      body.orderBy = this.orderBy;
      body.asc = this.asc;

      await servicePackageService
        .get(body)
        .then(res => {
          // this.data = this.data.concat(res.data);
          this.dataTable = this.dataTable.concat(res.data);
          this.paging.total = res.total;
        })
        .finally(() => (this.isLoading = false));
    },
    showMore() {
      if (this.paging.total - this.dataTable.length > 0) {
        this.paging.offset += this.paging.limit;
        this.getAll();
      }
    },
    changeOrderListService() {
      const tmp = [];
      this.dataTable.forEach(element => {
        tmp.push(element.id);
      });

      servicePackageService.sortService(tmp).then(res => {
        _alert(res, this.$t(res.data), false);
      });
    },
    // getAll() {
    //   if (this.checkAll === true) {
    //     this.selected = [...this.listFilter];
    //   } else {
    //     this.selected = [];
    //   }
    // },
    checkAllSelect() {
      if (this.selected.length === this.listFilter.length) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },
    updateStatus(item) {
      servicePackageService.updateStatus(item.id).then(res => {
        _alert(res, this.$t(res.data), false);
      });
      this.getAll(true);
    },
    deactiveAll() {
      const body = [];
      this.selected.forEach(element => {
        body.push(element.id);
      }
      );
      servicePackageService.updateStatusAll(body).then(res => {
        this.dialog = false;
        _alert(res, this.$t(res.data), res.responseCode === 0);
      });
    },
    addNew() {
      this.$router.push({ name: "serviceDetail", params: { type: 'create', id: 0 } });
    },
    editItem(item) {
      this.$router.push({ name: "serviceDetail", params: { type: 'edit', id: item.id } });
    },
    deleteService(item) {
      servicePackageService.deleteService(item.id).then(res => {
        _alert(res, this.$t(res.data), false);
        this.getAll(true);
      });
    },
    deleteServiceList(items) {
      const body = [];
      items.forEach(element => {
        body.push(element.id);
      }
      );
      servicePackageService.deleteServiceList(body).then(res => {
        _alert(res, this.$t(res.data), true);
      });
    },
  }
};
</script>